import { selectGetAdminSession } from "features/admin/presentation/slices/get-admin-session.slice";
import { createQueryParams } from "features/config/helpers";
import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { pusher } from "features/shared/constants";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { getOrderComment } from "../slices/get-order-comment.slice";
import { selectPostComment } from "../slices/post-comment.slice";
import { getProductData } from "../slices/get-product-data.slice";

interface TransactionParam {
  postSuccess: boolean;
  message: string;
}

interface OrderDataParam {
  message: string;
}

export function StockOrderProcessWrapper() {
  const dispatch = useAppDispatch();
  const { orderId } = useParams();

  const postCommentState = useAppSelector(selectPostComment);

  useEffect(() => {
    pusher.unsubscribe("stock-comment");
    const stockOrderCommentChannel = pusher.subscribe("stock-comment");

    stockOrderCommentChannel.bind("updateComment", (data: TransactionParam) => {
      if (data.postSuccess && orderId) {
        const query = createQueryParams({ orderId: orderId });
        dispatch(getOrderComment(query));
      }
    });
  }, [postCommentState, orderId, dispatch]);

  useEffect(() => {
    const stockOrderDataChannel = pusher.subscribe("stock-order-data");

    stockOrderDataChannel.bind("updateOrderData", (data: OrderDataParam) => {
      if (orderId) {
        dispatch(getProductData({ orderId: orderId }));
      }
    });

    return () => {
      stockOrderDataChannel.unbind("updateOrderData");
      pusher.unsubscribe("stock-order-data");
    };
  }, [orderId, dispatch]);

  return (
    <>
      <Outlet />
    </>
  );
}
